/**
 * @generated SignedSource<<a2076748fe91daf09c65aa10a8185576>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SharedItemTile_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"BuyerProductTile_user" | "FavoritesItemProvider_user">;
  readonly " $fragmentType": "SharedItemTile_user";
};
export type SharedItemTile_user$key = {
  readonly " $data"?: SharedItemTile_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"SharedItemTile_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SharedItemTile_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FavoritesItemProvider_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BuyerProductTile_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "c501a00f474299b79d8d18e7d31b0f58";

export default node;
